// src/redux/userInfoSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfo } from '@typing/userInfo';
import { logout } from './auth/authReducer';

interface UserInfoState {
    users: UserInfo[];
}

const initialState: UserInfoState = {
    users: [],
};

const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        addUser(state, action: PayloadAction<UserInfo>) {
            state.users.push(action.payload);
        },
        updateUser(state, action: PayloadAction<UserInfo>) {
            const index = state.users.findIndex(user => user.tenantId === action.payload.tenantId);
            if (index !== -1) {
                state.users[index] = action.payload;
            }
        },
        deleteUser(state, action: PayloadAction<string>) {
            state.users = state.users.filter(user => user.tenantId !== action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => initialState);
      },
});

export const { addUser, updateUser, deleteUser } = userInfoSlice.actions;
export default userInfoSlice.reducer;
